/**
 * 该文件提供所有玩法对指纹以及指纹对规则的匹配关系
 * 指纹命名规则：
 */

// 所有对应关系
const TOKENS = {
	MULTI: [
	  '五星-五星直选-复式',
	  '四星-四星直选-复式',
	  '后三码-后三直选-复式',
	  '前三码-前三直选-复式',
	  '中三码-中三直选-复式',
	  '二码-二星直选-后二直选(复式)',
	  '二码-二星直选-前二直选(复式)',
	  '大小单双-大小单双-后二',
	  '大小单双-大小单双-前二',
	  '后三码-后三直选-直选复式',
	  '前三码-前三直选-直选复式',
	  '二码-二星直选-前二直选复式',
	  '二码-二星直选-后二直选复式',
	  '二同号单选-二同号单选-标准选号',
	  '三码-直选-复式',
	  '二码-二码-后二直选复式',
	  '二码-二星-后二直选复式',
	  '二码-二星-前二直选复式',
	  '二星-二星-后二直选复式',
	  '二星-二星-前二直选复式',
	  '大小单双-大小单双组合-前三',
	  '大小单双-大小单双组合-后三',
	  '大小单双-大小单双组合-后二',
	  '大小单双-大小单双组合-前二'
	],
	SINGLE_5: ['五星-五星直选-单式'],
	COMBINATION: ['五星-五星直选-组合', '四星-四星直选-组合'],
	MULTI_COMBINATION: [
	  '五星-五星组选-组选120',
	  '五星-五星组选-组选60 ',
	  '五星-五星组选-组选30',
	  '五星-五星组选-组选20',
	  '五星-五星组选-组选10',
	  '五星-五星组选-组选5',
	  '四星-四星组选-组选24',
	  '四星-四星组选-组选12',
	  '四星-四星组选-组选6',
	  '四星-四星组选-组选4',
	  '五星-五星组选-组选60'
	],
	SINGLE_4: ['四星-四星直选-单式'],
	SINGLE_3: [
	  '后三码-后三直选-单式',
	  '前三码-前三直选-单式',
	  '中三码-中三直选-单式',
	  '后三码-后三直选-直选单式',
	  '前三码-前三直选-直选单式',
	  '三码-直选-单式'
	],
	SUM_PLUS_DIRECT_3: ['后三码-后三直选-直选和值', '前三码-前三直选-直选和值', '中三码-中三直选-直选和值', '三码-直选-直选和值', '三码-直选-和值'],
	MULTI_COMBINATION_3: ['后三码-后三组选-组三', '前三码-前三组选-组三', '中三码-中三组选-组三', '三码-组选-组三'],
	'COMBINATION-CHOSEN_3': [
	  '后三码-后三组选-组六',
	  '前三码-前三组选-组六',
	  '中三码-中三组选-组六',
	  '三不同号-三不同号-标准选号',
	  '三码-三码-前三组选复式',
	  '任选复式-任选复式-三中三',
	  '三码-组选-组六',
	  '任选-任选型-任选3',
	  '不定胆-四星不定胆-四星三码不定胆',
	  '不定胆-五星不定胆-五星三码不定胆'
	],
	SINGLE_GROUP_3: [
	  '后三码-后三组选-混合组选',
	  '前三码-前三组选-混合组选',
	  '中三码-中三组选-混合组选',
	  '后三码-后三组选-混合',
	  '前三码-前三组选-混合',
	  '三码-组选-混合',
	  '中三码-中三组选-混合'
	],
	SUM_PLUS_GROUP_3: ['后三码-后三组选-组选和值', '前三码-前三组选-组选和值', '中三码-中三组选-组选和值', '三码-组选-组选和值', '三码-组选-和值'],
	SINGLE_2: [
	  '二码-二星直选-后二直选(单式)',
	  '二码-二星直选-前二直选(单式)',
	  '二码-二星直选-前二直选单式',
	  '二码-二星直选-后二直选单式',
	  '二码-二星-后二直选单式',
	  '二码-二星-前二直选单式',
	  '二码-二码-后二直选单式',
	  '二星-二星-后二直选单式',
	  '二星-二星-前二直选单式'
	],
	SUM_PLUS_DIRECT_2: ['二码-二星直选-后二直选和值', '二码-二星直选-前二直选和值'],
	MULTI_COMBINATION_2: [
	  '二码-二星组选-后二组选(复式)',
	  '二码-二星组选-前二组选(复式)',
	  '不定胆-三星不定胆-后三二码不定胆',
	  '不定胆-三星不定胆-前三二码不定胆',
	  '二码-二星组选-前二组选复式',
	  '二码-二星组选-后二组选复式',
	  '二不同号-二不同号-标准选号',
	  '二码-二码-前二组选复式',
	  '任选复式-任选复式-二中二',
	  '二码-二星-后二组选复式',
	  '二码-二星-前二组选复式',
	  '二码-二码-后二组选复式',
	  '任选-任选型-任选2',
	  '二星-二星-后二组选复式',
	  '二星-二星-前二组选复式',
	  '不定胆-三星不定胆-中三二码不定胆',
	  '不定胆-四星不定胆-四星二码不定胆',
	  '不定胆-五星不定胆-五星二码不定胆'
	],
	SINGLE_GROUP_2: [
	  '二码-二星组选-后二组选(单式)',
	  '二码-二星组选-前二组选(单式)',
	  '二码-二星组选-前二组选单式',
	  '二码-二星组选-后二组选单式',
	  '二码-二星-后二组选单式',
	  '二码-二星-前二组选单式',
	  '二码-二码-后二组选单式',
	  '二星-二星-后二组选单式',
	  '二星-二星-前二组选单式'
	],
	SUM_PLUS_GROUP_2: ['二码-二星组选-后二组选和值', '二码-二星组选-前二组选和值'],
	TIMES_1: [
	  '定位胆-定位胆-定位胆',
	  '不定胆-三星不定胆-后三一码不定胆',
	  '不定胆-三星不定胆-前三一码不定胆',
	  '大小单双-大小单双-总和',
	  '趣味-特殊-一帆风顺',
	  '趣味-特殊-好事成双',
	  '趣味-特殊-三星报喜',
	  '趣味-特殊-四季发财',
	  '和值尾数-和值尾数-前三和值尾数',
	  '和值尾数-和值尾数-中三和值尾数',
	  '和值尾数-和值尾数-后三和值尾数',
	  '龙虎-龙虎-龙虎斗',
	  '龙虎-龙虎-玄麟斗',
	  '龙虎斗-龙虎-龙虎斗',
	  '龙虎斗-龙虎-玄麟斗',
	  '百家乐-百家乐-庄闲',
	  '百家乐-百家乐-和',
	  '百家乐-百家乐-对子',
	  '百家乐-百家乐-豹子',
	  '百家乐-百家乐-天王',
	  '全5中1-全5中1-组选1',
	  '全5中1-全5中1-组选5',
	  '全5中1-全5中1-组选10',
	  '全5中1-全5中1-组选20',
	  '全5中1-全5中1-组选30',
	  '全5中1-全5中1-组选60',
	  '全5中1-全5中1-组选120',
	  '二同号复选-二同号复选-二同号复选',
	  '三同号单选-三同号单选-三同号单选',
	  '和值-和值-和值',
	  '猜冠军-猜冠军-猜冠军',
	  '定位胆-定位胆-1～5位定位胆',
	  '定位胆-定位胆-6～10位定位胆',
	  '定位胆-定位胆-1～10位定位胆',
	  '大小单双-大小单双-冠军',
	  '大小单双-大小单双-亚军',
	  '大小单双-大小单双-季军',
	  '和值-和值-冠亚和值',
	  '和值-和值-中二和值',
	  '和值-和值-后二和值',
	  '和值-三码-前三和值',
	  '和值-三码-后三和值',
	  '龙虎-龙虎-冠军龙虎',
	  '龙虎-龙虎-亚军龙虎',
	  '龙虎-龙虎-季军龙虎',
	  '龙虎-龙虎-第四名龙虎',
	  '龙虎-龙虎-第五名龙虎',
	  '独赢-独赢-独赢',
	  '位置-位置-1～5位位置',
	  '位置-位置-6～10位位置',
	  '和值-连赢-后二和值',
	  '和值-连赢-中二和值',
	  '和值-连赢-前二和值',
	  '和值-三连环-后三和值',
	  '和值-三连环-前三和值',
	  '不定胆-不定胆-前三位',
	  '趣味型-趣味型-定单双',
	  '趣味型-趣味型-猜中位',
	  '任选复式-任选复式-一中一',
	  '不定胆-不定胆-一码不定胆',
	  '趣味-趣味型-和值单双',
	  '趣味-趣味型-和值大小',
	  '趣味-趣味型-奇偶盘',
	  '趣味-趣味型-上下盘',
	  '趣味-趣味型-和值大小单双',
	  '任选-任选型-任选1',
	  '盘面-盘面-上下盘',
	  '盘面-盘面-奇偶盘',
	  '龙虎斗-龙虎-万千',
	  '龙虎斗-龙虎-万百',
	  '龙虎斗-龙虎-万十',
	  '龙虎斗-龙虎-万个',
	  '龙虎斗-龙虎-千百',
	  '龙虎斗-龙虎-千十',
	  '龙虎斗-龙虎-千个',
	  '龙虎斗-龙虎-百十',
	  '龙虎斗-龙虎-百个',
	  '龙虎斗-龙虎-十个',
	  '冠军-冠军-冠军',
	  '不定胆-三星不定胆-中三一码不定胆',
	  '不定胆-四星不定胆-四星一码不定胆',
	  '不定胆-五星不定胆-五星一码不定胆',
	  '大小单双-和值大小单双-五星和值',
	  '大小单双-和值大小单双-前三和值',
	  '大小单双-和值大小单双-中三和值',
	  '大小单双-和值大小单双-后三和值',
	  '大小单双-大小个数-五星大小个数',
	  '大小单双-大小个数-四星大小个数',
	  '大小单双-大小个数-前三大小个数',
	  '大小单双-大小个数-中三大小个数',
	  '大小单双-大小个数-后三大小个数',
	  '大小单双-单双个数-五星单双个数',
	  '大小单双-单双个数-四星单双个数',
	  '大小单双-单双个数-前三单双个数',
	  '大小单双-单双个数-中三单双个数',
	  '大小单双-单双个数-后三单双个数',
	  '牛牛-牛牛-牛牛'
	],
	ANY_CHOSEN_DIRECT_2: ['任选二-任二直选-直选复式'],
	ANY_SINGLE_DIRECT_2: ['任选二-任二直选-直选单式'],
	ANY_CHOSEN_DIRECT_2_SUM_PLUS: ['任选二-任二直选-直选和值'],
	ANY_CHOSEN_GROUP_2: ['任选二-任二组选-组选复式'],
	ANY_CHOSEN_SINGLE_2: ['任选二-任二组选-组选单式'],
	ANY_SUM_PLUS_GROUP_2: ['任选二-任二组选-组选和值'],
	ANY_CHOSEN_DIRECT_3: ['任选三-任三直选-直选复式'],
	SINGLE_DIRECT_3_POSITION: ['任选三-任三直选-直选单式'],
	ANY_CHOSEN_DIRECT_3_SUM_PLUS: ['任选三-任三直选-直选和值'],
	ANY_MULTI_COMBINATION_3: ['任选三-任三组选-组三'],
	'ANY_COMBINATION-CHOSEN_3': ['任选三-任三组选-组六'],
	ANY_SINGLE_GROUP_3: ['任选三-任三组选-混合组选'],
	ANY_SUM_PLUS_GROUP_3: ['任选三-任三组选-组选和值'],
	ANY_CHOSEN_DIRECT_4: ['任选四-任四直选-直选复式'],
	SINGLE_DIRECT_4_POSITION: ['任选四-任四直选-直选单式'],
	ANY_CHOSEN_GROUP_4: ['任选四-任四组选-组选24'],
	MULTI_COMBINATION_POSITION: ['任选四-任四组选-组选12', '任选四-任四组选-组选6', '任选四-任四组选-组选4'],
	SPAN_2: ['直选跨度-二码跨度-前二跨度', '直选跨度-二码跨度-后二跨度'],
	SPAN_3: ['直选跨度-三码跨度-前三跨度', '直选跨度-三码跨度-中三跨度', '直选跨度-三码跨度-后三跨度'],
	INCLUDE_3: ['组选包胆-组选包胆-前三包胆', '组选包胆-组选包胆-中三包胆', '组选包胆-组选包胆-后三包胆'],
	SHOUDONG_SINGLE_2: ['二不同号-二不同号-手动输入'],
	SHOUDONG_SAME_SINGLE_3: ['二同号单选-二同号单选-手动输入'],
	SHOUDONG_SINGLE_3: ['三不同号-三不同号-手动输入'],
	HEZHI: ['三不同号-三不同号-和值选号'],
	GENERAL_ELECTION: ['三同号通选-三同号通选-三同号通选', '三连号通选-三连号通选-三连号通选'],
	RANKING: [
	  '猜前二-猜前二-复式',
	  '猜前三-猜前三-复式',
	  '猜前四-猜前四-复式',
	  '猜前五-猜前五-复式',
	  '猜前六-猜前六-复式',
	  '连赢-连赢-复式',
	  '三连环-三连环-复式',
	  '四连环-四连环-复式',
	  '五连环-五连环-复式',
	  '六连环-六连环-复式',
	  '三码-三码-前三直选复式',
	  '二码-二码-前二直选复式',
	  '前二-猜前二-复式',
	  '前三-猜前三-复式',
	  '前四-猜前四-复式',
	  '前五-猜前五-复式',
	  '前六-猜前六-复式'
	],
	RANKING_SINGLE_2: ['猜前二-猜前二-单式', '连赢-连赢-单式', '二码-二码-前二直选单式', '前二-猜前二-单式'],
	RANKING_SINGLE_3: ['猜前三-猜前三-单式', '三连环-三连环-单式', '三码-三码-前三直选单式', '前三-猜前三-单式'],
	RANKING_SINGLE_4: ['猜前四-猜前四-单式', '四连环-四连环-单式', '前四-猜前四-单式'],
	RANKING_SINGLE_5: ['猜前五-猜前五-单式', '五连环-五连环-单式', '前五-猜前五-单式'],
	RANKING_SINGLE_6: ['猜前六-猜前六-单式', '六连环-六连环-单式', '前六-猜前六-单式'],
	RANKING_PK: ['竞速-竞速-竞速', '对决-对决-对决'],
	RANKING_SINGLE_GROUP_3: ['三码-三码-前三组选单式', '任选单式-任选单式-三中三'],
	RANKING_SINGLE_GROUP_2: ['二码-二码-前二组选单式', '任选单式-任选单式-二中二'],
	'COMBINATION-CHOSEN_4': ['任选复式-任选复式-四中四', '任选-任选型-任选4'],
	'COMBINATION-CHOSEN_5': ['任选复式-任选复式-五中五', '任选-任选型-任选5'],
	'COMBINATION-CHOSEN_6': ['任选复式-任选复式-六中五', '任选-任选型-任选6'],
	'COMBINATION-CHOSEN_7': ['任选复式-任选复式-七中五', '任选-任选型-任选7'],
	'COMBINATION-CHOSEN_8': ['任选复式-任选复式-八中五'],
	NUM_IN_NUM_1: ['任选单式-任选单式-一中一'],
	RANKING_SINGLE_GROUP_4: ['任选单式-任选单式-四中四'],
	RANKING_SINGLE_GROUP_5: ['任选单式-任选单式-五中五'],
	RANKING_SINGLE_GROUP_6: ['任选单式-任选单式-六中五'],
	NUM_IN_NUM_7: ['任选单式-任选单式-七中五'],
	NUM_IN_NUM_8: ['任选单式-任选单式-八中五']
  };
  
  export function getMatcher() {
	return TOKENS;
  }
  
  /**
   * 玩法对规则指纹的匹配关系(除去单式)
   * @param  {[type]} mathcherName [玩法匹配名称]
   * @return {[type]}              [玩法指纹]
   */
  export function method2Token(mathcherName) {
	return _.findKey(TOKENS, item => _.includes(item, mathcherName));
  }
  
  /**
   * 玩法指纹对规则项的匹配关系
   * @param  {[type]} token [玩法指纹]
   * @return {[type]}       [规则项]
   */
  export function token2Rules(token) {
	// 所有对应关系
	const RULES = {
	  // 复式
	  MULTI: ['multi'],
	  // 组合
	  COMBINATION: ['combination'],
	  // 普通M选3组合(组六)
	  'COMBINATION-CHOSEN_3': ['add-num-3', 'combination-chosen'],
	  'COMBINATION-CHOSEN_4': ['add-num-4', 'combination-chosen'],
	  'COMBINATION-CHOSEN_5': ['add-num-5', 'combination-chosen'],
	  'COMBINATION-CHOSEN_6': ['add-num-6', 'combination-chosen'],
	  'COMBINATION-CHOSEN_7': ['add-num-7', 'combination-chosen'],
	  'COMBINATION-CHOSEN_8': ['add-num-8', 'combination-chosen'],
	  //任三 （组六）
	  'ANY_COMBINATION-CHOSEN_3': ['add-num-3', 'combination-chosen', 'position-chosen', 'add-posnum-3'],
	  // 组3
	  MULTI_COMBINATION_3: ['add-num-2', 'combination-chosen', 'times-chosen'],
	  // 任三 组3
	  ANY_MULTI_COMBINATION_3: ['add-num-2', 'combination-chosen', 'add-posnum-3', 'times-chosen', 'position-chosen'],
	  // 组选
	  MULTI_COMBINATION: ['multi-combination'],
	  //二码组选
	  MULTI_COMBINATION_2: ['add-num-2', 'combination-chosen'],
	  // 任四组选12,6,4
	  MULTI_COMBINATION_POSITION: ['multi-combination', 'add-posnum-4', 'position-chosen'],
	  // 直选5位单式
	  SINGLE_5: ['add-num-5', 'single'],
	  // 组选3位单式
	  SINGLE_GROUP_3: ['add-num-3', 'add-flag-group', 'single'],
	  // 组选2位单式
	  SINGLE_GROUP_2: ['add-num-2', 'add-flag-group', 'single'],
	  //任三 混合组选
	  ANY_SINGLE_GROUP_3: ['add-num-3', 'add-flag-group', 'single', 'add-posnum-3', 'position-chosen'],
	  // 直选和值0-9位数，选3
	  SUM_PLUS_DIRECT_3: ['add-flag-direct', 'add-num-3', 'sum-plus'],
	  //直选和值，选2
	  SUM_PLUS_DIRECT_2: ['add-flag-direct', 'add-num-2', 'sum-plus'],
	  // 组选和值0-9位数 选3
	  SUM_PLUS_GROUP_3: ['add-flag-group', 'add-num-3', 'sum-plus'],
	  //任三 组选和值
	  ANY_SUM_PLUS_GROUP_3: ['add-flag-group', 'add-num-3', 'sum-plus', 'add-posnum-3', 'position-chosen'],
	  //组选和值  选2
	  SUM_PLUS_GROUP_2: ['add-flag-group', 'add-num-2', 'sum-plus'],
	  //任二组选和值
	  ANY_SUM_PLUS_GROUP_2: ['add-flag-group', 'add-num-2', 'sum-plus', 'add-posnum-2', 'position-chosen'],
	  //任四组选24
	  ANY_CHOSEN_GROUP_4: ['add-flag-group', 'add-num-4', 'combination-chosen', 'position-chosen'],
	  //任二直选单式
	  ANY_SINGLE_DIRECT_2: ['add-num-2', 'add-flag-direct', 'single', 'position-chosen'],
	  // 任二直选复式
	  ANY_CHOSEN_DIRECT_2: ['add-num-2', 'any-chosen', 'any-solo'],
  
	  // 任二组选复式
	  ANY_CHOSEN_GROUP_2: ['add-num-2', 'combination-chosen', 'position-chosen'],
	  // 任三直选复式
	  ANY_CHOSEN_DIRECT_3: ['add-num-3', 'any-chosen', 'any-solo'],
	  // 任四直选复式
	  ANY_CHOSEN_DIRECT_4: ['add-num-4', 'any-chosen', 'any-solo'],
	  // 一号一注
	  TIMES_1: ['times-chosen'],
	  // 任选二直选和值
	  ANY_CHOSEN_DIRECT_2_SUM_PLUS: ['add-num-2', 'add-flag-direct', 'sum-plus', 'add-posnum-2', 'position-chosen'],
	  // 任选三直选和值
	  ANY_CHOSEN_DIRECT_3_SUM_PLUS: ['add-num-3', 'add-flag-direct', 'sum-plus', 'add-posnum-3', 'position-chosen'],
	  // 跨度2
	  SPAN_2: ['add-num-2', 'span-chosen'],
	  // 跨度3
	  SPAN_3: ['add-num-3', 'span-chosen'],
	  // 三位包胆
	  INCLUDE_3: ['add-num-54', 'times-chosen'],
	  // 三码任选直选单式
	  SINGLE_DIRECT_3_POSITION: ['add-num-3', 'add-flag-direct', 'single', 'position-chosen'],
	  // 四码任选直选单式
	  SINGLE_DIRECT_4_POSITION: ['add-num-4', 'add-flag-direct', 'single', 'position-chosen'],
	  //四星直选单式
	  SINGLE_4: ['add-num-4', 'single'],
	  //后三码直选单式
	  SINGLE_3: ['add-num-3', 'single'],
	  //二码直选单式
	  SINGLE_2: ['add-num-2', 'single'],
	  //任二组选单式
	  ANY_CHOSEN_SINGLE_2: ['add-num-2', 'single', 'add-posnum-2', 'position-chosen', 'add-flag-group'],
	  //猜名次复式
	  RANKING: ['ranking-chosen'],
	  //猜前二单式
	  RANKING_SINGLE_2: ['add-num-1', 'single'],
	  //11选5 前二组选单式
	  RANKING_SINGLE_GROUP_2: ['add-num-1', 'single', 'add-flag-group'],
	  //猜前三单式
	  RANKING_SINGLE_3: ['add-num-2', 'single'],
	  //11选5 前三组选单式
	  RANKING_SINGLE_GROUP_3: ['add-num-2', 'single', 'add-flag-group'],
	  //猜前四单式
	  RANKING_SINGLE_4: ['add-num-3', 'single'],
	  //11选5 四中四
	  RANKING_SINGLE_GROUP_4: ['add-num-3', 'single', 'add-flag-group'],
	  //猜前五单式
	  RANKING_SINGLE_5: ['add-num-4', 'single'],
	  //11选5 五中五
	  RANKING_SINGLE_GROUP_5: ['add-num-4', 'single', 'add-flag-group'],
	  //猜前六单式
	  RANKING_SINGLE_6: ['add-num-5', 'single'],
	  //11选5 六中五
	  RANKING_SINGLE_GROUP_6: ['add-num-5', 'single', 'add-flag-group'],
	  //一中一
	  NUM_IN_NUM_1: ['add-num-0', 'single'],
	  //七中五
	  NUM_IN_NUM_7: ['add-num-6', 'single', 'add-flag-group'],
	  //八中五
	  NUM_IN_NUM_8: ['add-num-7', 'single', 'add-flag-group'],
	  // 组3
	  HEZHI: ['add-num-3', 'add-flag-group', 'sum-plus-dif'],
	  // 三不同码手动输入
	  SHOUDONG_SINGLE_3: ['add-num-3', 'single'],
	  // 二不同码手动输入
	  SHOUDONG_SINGLE_2: ['add-num-2', 'single'],
	  // 二同号手动输入
	  SHOUDONG_SAME_SINGLE_3: ['add-num-3', 'single', 'add-flag-group'],
	  RANKING_PK: ['without-format-codes', 'ranking-pk'],
	  DANTUO_DIF_3: ['dantuo-dif-3'],
	  DANTUO_DIF_2: ['dantuo-dif-2'],
	  GENERAL_ELECTION: ['general-election']
	};
  
	return RULES[token];
  }
  
  /**
   * 六合彩规则
   * @param  {[type]} lotteryId [彩种ID]
   * @return {[type]}           [description]
   */
  export function mathLhcRules(lotteryId) {
	let ruleSuite = [];
	// 以彩种ID作为判断依据
	switch (Number(lotteryId)) {
	  case 20: {
		ruleSuite = ['lhc-common'];
	  }
	}
	// 返回
	return ruleSuite;
  }
